

    <div class=closeFlex><h1 style="margin: 0px; cursor: pointer;" (click)="close($event)">&times;</h1></div>
      <div class=hflex>
            <div class=avatar>
                <h2>{{profile?.firstname | firstLetter}}{{profile?.lastname | firstLetter}}</h2>
            </div>
            <div class="name_email">
                <h4>{{profile?.firstname }} {{profile?.lastname}}</h4>
                <span>{{profile?.email}}</span>
                <span *ngIf="!!profile?.zipcode">Zip/Postal: {{profile?.zipcode}}</span>
            </div>
            <div class="name_email">
                <span >{{profile?.city}} <span *ngIf="!!profile?.city">,</span> {{profile?.country}}</span>
                <span *ngIf="!!profile?.phone">Phone: {{profile?.phone}}</span>
                <span *ngIf="!!profile?.createdAt">Created: {{profile?.createdAt | date}}</span>
                <span *ngIf="!!profile?.lastUpdated">Last Active: {{profile?.lastUpdated | date}}</span>
            </div>
            
    </div>

    <div class=spread>
        <button mat-raised-button (click)="toggleTextArea()">{{!!showing ? 'Cancel' : 'Message'}}</button>
        <button [@item] *ngIf="!!showing" class="send" mat-raised-button (click)="send($event)">Send</button>
    </div>

    <textarea  [ngClass]="{'open': !!showing, 'closed': !showing}" [(ngModel)]=message></textarea>
  
      


